export interface Identity {
  id: string;
  name: string;
}

const STORAGE_KEY = 'chatsi.identity.v1';

function newId(): string {
  const cryptoApi = globalThis.crypto;
  if (cryptoApi?.randomUUID) return cryptoApi.randomUUID();
  return `${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 10)}`;
}

export function saveIdentity(identity: Identity) {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(identity));
  } catch {
    // Private mode or storage disabled: the identity lasts for this page only.
  }
}

/** Stable per-browser identity so each client sees its own messages on the right. */
export function loadIdentity(): Identity {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (raw) {
      const parsed = JSON.parse(raw) as Partial<Identity>;
      if (parsed.id) {
        return { id: String(parsed.id), name: typeof parsed.name === 'string' ? parsed.name : '' };
      }
    }
  } catch {
    // fall through and create a fresh identity
  }
  const identity: Identity = { id: newId(), name: '' };
  saveIdentity(identity);
  return identity;
}
